import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	signal,
	ViewEncapsulation,
} from '@angular/core';

import { LinkListComponent } from '@valk-nx/components/ui-link-list/src/lib/link-list.component';
import type { LinkListItem } from '@valk-nx/components/ui-link-list/src/lib/link-list.interface';
import { ClickOutsideDirective } from '@valk-nx/core/lib/directives/click-outside/click-outside.directive';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [ClickOutsideDirective, LinkListComponent, SVG_ICON_IMPORTS],
	selector: 'vp-dropdown-button',
	templateUrl: './dropdown-button.html',
})
export class DropdownButtonComponent {
	title = input.required<string>();
	items = input.required<LinkListItem[]>();

	isOpen = signal(false);

	testIdName = computed<string>(() => {
		return (
			this.title().toLowerCase().replaceAll(/\s+/g, '-') +
			'-dropdown-button'
		);
	});

	toggle(): void {
		this.isOpen.update((open) => !open);
	}

	close(): void {
		this.isOpen.set(false);
	}
}
